import _, { forEach } from "lodash";
import * as EmailValidator from 'email-validator';
import router from '../router';
import store from "@/store";
import api from '../utils/api';

var ones = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
var tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
var teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];

function convert_millions(num: number): string {
    if (num >= 1000000) {
        return convert_millions(Math.floor(num / 1000000)) + " million " + convert_thousands(num % 1000000);
    } else {
        return convert_thousands(num);
    }
}

function convert_thousands(num: number) {
    if (num >= 1000) {
        return convert_hundreds(Math.floor(num / 1000)) + " thousand " + convert_hundreds(num % 1000);
    } else {
        return convert_hundreds(num);
    }
}

function convert_hundreds(num: number) {
    if (num > 99) {
        return ones[Math.floor(num / 100)] + " hundred " + convert_tens(num % 100);
    } else {
        return convert_tens(num);
    }
}

function convert_tens(num: number) {
    if (num < 10) return convert_ones(num);
    else if (num >= 10 && num < 20) return teens[num - 10];
    else {
        return tens[Math.floor(num / 10)] + " " + convert_ones(num % 10);
    }
}

function convert_ones(num: number) {
    if ((num % 1) ===0) return ones[num];
    let last_digit = ones[Math.floor(num)];
    if (last_digit ==='zero') last_digit = '' ;
    return last_digit
}

function convert_digits(num: string): string {
    if (num.length ===0) return ""
    else if (num[0] ==="-") return "minus " + convert_digits(num.slice(1));
    else if (num[0] ===".") return "point " + convert_digits(num.slice(1));
    else return ones[Number(num[0])] + " " + convert_digits(num.slice(1));
}

function convert(num: number): string {
    let x = ""
    if (num < 0) return "minus " + convert(-num);
    else if (num ===0) return "zero";
    else if (num < 1) return "zero " + convert_ones(num);
    else x = convert_millions(num);
    if (_.endsWith(x, "zero")) {
        return _.trimEnd(x, "zero");
    }
    return x;
}

function pad_convert(num: string) {
    if ((num[0] ==="0") || (num.slice(0,2) ==="-0")) return " " + convert_digits(num) + " ";
    let i = num.indexOf(".")
    let point = ""
    if (i ===-1) {
        if (num.length >= 10) return " " + convert_digits(num) + " ";
    }
    else {
        if (i >= 10) return " " + convert_digits(num) + " ";
        point = " " + convert_digits(num.slice(i));
    }
    return " " + convert(Number(num)) + point + " ";
}

function pad_convert_unit_tests() {
    pad_convert('0') ==="zero";
    pad_convert('4') ==="four";
    pad_convert('10') ==="ten";
    pad_convert('18') ==="eighteen";
    pad_convert('20') ==="twenty";
    pad_convert('39') ==="thirty nine";
    pad_convert('100') ==="one hundred";
    pad_convert('263') ==="two hundred sixty three";
    pad_convert('1000') ==="one thousand";
    pad_convert('2009') ==="two thousand nine";
    pad_convert('5462') ==="five thousand four hundred sixty two";
    pad_convert('10203045') ==="ten million two hundred three thousand forty five";
    pad_convert('23456789') ==="twenty three million four hundred fifty six thousand seven hundred eighty nine";
    pad_convert('1234567890') ==="one two three four five six seven eight nine zero";
    pad_convert('12345678900987654321') ==="one two three four five six seven eight nine zero zero nine eight seven six five four three two one";
    pad_convert('-1534') ==="minus one thousand five hundred thirty four";
    pad_convert('0.1') ==="zero point one";
    pad_convert('0.8') ==="zero point eight";
    pad_convert('12340.56789') ==="twelve thousand three hundred forty point five six seven eight nine";
    pad_convert('1234.056789') ==="one thousand two hundred thirty four point zero five six seven eight nine";
    pad_convert('0.0123456789') ==="zero point zero one two three four five six seven eight nine";
    pad_convert('1.23456789') ==="one point two three four five six seven eight nine";
    pad_convert('-0.1') ==="minus zero point one";
    pad_convert('-12340.56789') ==="minus twelve thousand three hundred forty point five six seven eight nine";
    pad_convert('12345678901.123456789') ==="one two three four five six seven eight nine zero one point one two three four five six seven eight nine";
    pad_convert('12345678910.123456789') ==="one two three four five six seven eight nine one zero point one two three four five six seven eight nine";
    pad_convert('1.0') ==="one point zero";
    pad_convert('1081349.10') ==="one million eighty one thousand three hundred forty nine point one zero";
    pad_convert('123456789098.70') ==="one two three four five six seven eight nine zero nine eight point seven zero";
    pad_convert('7030.590') ==="seven thousand thirty point five nine zero";
    pad_convert('10000.234567890') ==="ten thousand point two three four five six seven eight nine zero";
    pad_convert('-17802.2345678901') ==="minus seventeen thousand eight hundred two point two three four five six seven eight nine zero one";
    pad_convert('00') ==="zero zero";
    pad_convert('00.30') ==="zero zero point three zero";
    pad_convert('000345.010') ==="zero zero zero three four five point zero one zero";
}

export default class helper {

    static releaseMic = function (stream: any) {
        try {
            stream.getTracks().forEach((track: any) => {
                console.log("🚀 ~ file: helpers.ts ~ line 128 ~ helper ~ stream.getTracks ~ track STOP", track)
                track.stop();
            });
        } catch (err) {
            console.log("🚀 ~ file: helpers.ts ~ line 130 ~ helper ~ err", err)      
        }
    }
    // change old url to new
    static getUrl = function (url: string ) {
        if ((url ==="https://www.ihearu.app/dev") ||
            (url ==="https://www.ihearu.app/dev/")) {
            url = "https://api.aihearu.com/dev/";
        } else if ((url ==="https://www.ihearu.app") ||
            (url ==="https://www.ihearu.app/")) {
            url = "https://api.aihearu.com/";
        }
        return url;
    }

    static getShareCode(token: string) {
        if (
            location.hostname === "beta.aihearu.com" ||
            location.search === "?prod"
        ) {
            return "https://captions.aihearu.com/share/" + token;

        }
        return "https://zoom-caption-dev.web.app/share/" + token;
    }

    static beep = function() {
        var snd = new Audio("data:audio/wav;base64,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");
        // var snd = new Audio('data:audio/wav;base64,UklGRl9vT19XQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YU');
        // var snd = new Audio("https://html.com//wp-content/uploads/flamingos.mp3");
        snd.play();
        snd.onended = (event) => {
            console.log("🚀 ~ file: recorder.js ~ line 220 ~ Recorder ~ beep ~ event", event);
        }
    }
    static sleep = function (ms: number | undefined) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static emailValidator = function (email: string) {
        return EmailValidator.validate(email);
    }
    
    static replaceCommands = function (text: string) {
        let lines = text.split('\n');
        let clean = "";
        const name: string = store.getters.getSpeaker.displayName;
        const nameWords = name.split(' ');
        
        lines.forEach((line) => {
            if (line === "[AI-MY-NAME-IS]") {
                clean += "My name is " + name+ "\n";
            } else if (line === "[AI-NAME-WORDS]") {
                nameWords.forEach((word: string) => {
                    clean += word + "\n";
                });
            } else if (line === "[AI-DISPLAY-NAME]") {
                    clean += name + "\n";
            } else {
                clean += line + "\n";
            }
        })

        return clean;
    }

    static cleanCorpus = function (str: string, breakOnSpecialChars = true, maxLength = 70) {
        let clean = str;

        // Remove diacritics from the string
        // Source: https://stackoverflow.com/a/37511463
        clean = clean.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        clean = clean.replace(/-?\d+(\.\d+)?/g, pad_convert);

        // Replace ’ with '
        clean = clean.replace(/’/g, "'");

        // Replace all non alphanumeric characters with "\n"
        if (breakOnSpecialChars) {
            clean = clean.replace(/[^a-z\s'-]/gi, '\n').replace(/ +/g, " ");
        } else {
            clean = clean.replace(/[^a-z\s'-]/gi, ' ').replace(/ +/g, " ");
        }

        // Word wrap
        // Source: https://stackoverflow.com/a/51506718
        const wrap = (s:string, w:number) => s.replace(
            new RegExp(`(?![^\\n]{1,${w}}$)([^\\n]{1,${w}})\\s`, 'g'), '$1\n'
        );

        if (maxLength > 0) {
            clean = wrap(clean, maxLength);
        }

        // Replace - with <SPACE>
        clean = clean.replace(/-/g, " ");

        // Remove leading and trailing spaces, empty lines and multiple spaces
        clean = clean.replace(/^\s+/gm, "").replace(/\s+$/gm, "").replace(/ +/g, " ");

        return clean;
    }

    static buddyVoice(selectedVoice: string) {
        const voice = window.speechSynthesis.getVoices().filter(function (voice) {
            return voice.name === selectedVoice;
        });
        return voice[0];
    }

    static goto(url: string) {
        console.debug("🚀 ~ file: helpers.ts ~ line 195 ~ helper ~ goto ~ url", url)
        router.push(url).catch(err => { 
          console.log("ignore router error", err);
          return true;
        });
    }
    static  daysIntoYear() {
        const date = new Date();
        return (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
    }

    static postAudio(vm: any, url: string, text: string) {
      let meta = {
        text: text,
        type: "run",
        state: "draft",
        url: url,
        textEdited: false,
        inferences: {},
        version: vm.$store.getters.getVersion,
        corpusId: "",
        corpusText: ""
      }
      meta.version.browser = vm.$browserDetect.meta;
      api.postAudio(meta, () => {
        console.log("🚀 ~ file: helpers.ts ~ line 267 ~ helper ~ api.postAudio ~ meta", vm.$options.name, meta)
      }, (err) => {
        console.error(
          "🚀 ~ file: helpers.ts ~ line 269 ~ helper ~ api.postAudio ~ err",
          vm.$options.name, err
        );
      });
    }
}
